var map = {
	"./": 310,
	"./UserSettings": 1161,
	"./UserSettings.dictionary": 344,
	"./UserSettings.dictionary.json": 344,
	"./UserSettings.tsx": 1161,
	"./UserSettingsDeferred": 377,
	"./UserSettingsDeferred.tsx": 377,
	"./components/ChangeButton": 866,
	"./components/ChangeButton/": 866,
	"./components/ChangeButton/ChangeButton.module.scss": 942,
	"./components/ChangeButton/index": 866,
	"./components/ChangeButton/index.tsx": 866,
	"./components/SettingToggler": 923,
	"./components/SettingToggler/": 923,
	"./components/SettingToggler/SettingToggler.module.scss": 1056,
	"./components/SettingToggler/index": 923,
	"./components/SettingToggler/index.tsx": 923,
	"./components/SettingsLoader": 940,
	"./components/SettingsLoader/": 940,
	"./components/SettingsLoader/index": 940,
	"./components/SettingsLoader/index.tsx": 940,
	"./components/SettingsSection": 837,
	"./components/SettingsSection/": 837,
	"./components/SettingsSection/SettingsSection.module.scss": 855,
	"./components/SettingsSection/index": 837,
	"./components/SettingsSection/index.tsx": 837,
	"./components/ThemeSetting": 992,
	"./components/ThemeSetting/": 992,
	"./components/ThemeSetting/ThemeSetting": 993,
	"./components/ThemeSetting/ThemeSetting.dictionary": 939,
	"./components/ThemeSetting/ThemeSetting.dictionary.json": 939,
	"./components/ThemeSetting/ThemeSetting.explanation": 1162,
	"./components/ThemeSetting/ThemeSetting.explanation.ts": 1162,
	"./components/ThemeSetting/ThemeSetting.module.scss": 1052,
	"./components/ThemeSetting/ThemeSetting.tsx": 993,
	"./components/ThemeSetting/components/ThemeCardWrapper": 910,
	"./components/ThemeSetting/components/ThemeCardWrapper/": 910,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper": 884,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.module.scss": 938,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.tsx": 884,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard": 865,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/": 865,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard": 849,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.module.scss": 885,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.tsx": 849,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem": 850,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/": 850,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem": 840,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.module.scss": 856,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.tsx": 840,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index": 850,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index.ts": 850,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index": 865,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index.ts": 865,
	"./components/ThemeSetting/components/ThemeCardWrapper/index": 910,
	"./components/ThemeSetting/components/ThemeCardWrapper/index.ts": 910,
	"./components/ThemeSetting/index": 992,
	"./components/ThemeSetting/index.ts": 992,
	"./components/UserMainSettings": 994,
	"./components/UserMainSettings/": 994,
	"./components/UserMainSettings/UserContacts": 941,
	"./components/UserMainSettings/UserContacts/": 941,
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary": 998,
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary.json": 998,
	"./components/UserMainSettings/UserContacts/index": 941,
	"./components/UserMainSettings/UserContacts/index.tsx": 941,
	"./components/UserMainSettings/UserEmail": 960,
	"./components/UserMainSettings/UserEmail/": 960,
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary": 961,
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary.json": 961,
	"./components/UserMainSettings/UserEmail/UserEmail.module.scss": 867,
	"./components/UserMainSettings/UserEmail/components/EmailModal": 995,
	"./components/UserMainSettings/UserEmail/components/EmailModal/": 995,
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary": 1055,
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary.json": 1055,
	"./components/UserMainSettings/UserEmail/components/EmailModal/index": 995,
	"./components/UserMainSettings/UserEmail/components/EmailModal/index.tsx": 995,
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm": 943,
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm.tsx": 943,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm": 887,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/": 887,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary": 912,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary.json": 912,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index": 887,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index.tsx": 887,
	"./components/UserMainSettings/UserEmail/components/ModalBody": 911,
	"./components/UserMainSettings/UserEmail/components/ModalBody/": 911,
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary": 944,
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary.json": 944,
	"./components/UserMainSettings/UserEmail/components/ModalBody/index": 911,
	"./components/UserMainSettings/UserEmail/components/ModalBody/index.tsx": 911,
	"./components/UserMainSettings/UserEmail/components/ModalContent": 1054,
	"./components/UserMainSettings/UserEmail/components/ModalContent.tsx": 1054,
	"./components/UserMainSettings/UserEmail/components/ModalFooter": 996,
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary": 945,
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary.json": 945,
	"./components/UserMainSettings/UserEmail/components/ModalFooter.tsx": 996,
	"./components/UserMainSettings/UserEmail/components/ModalHeader": 913,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/": 913,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary": 946,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary.json": 946,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index": 913,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index.tsx": 913,
	"./components/UserMainSettings/UserEmail/constants": 851,
	"./components/UserMainSettings/UserEmail/constants.ts": 851,
	"./components/UserMainSettings/UserEmail/email-form-validation": 1053,
	"./components/UserMainSettings/UserEmail/email-form-validation.ts": 1053,
	"./components/UserMainSettings/UserEmail/index": 960,
	"./components/UserMainSettings/UserEmail/index.tsx": 960,
	"./components/UserMainSettings/UserMainSettings.module.scss": 997,
	"./components/UserMainSettings/UserPersonalData": 914,
	"./components/UserMainSettings/UserPersonalData/": 914,
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary": 947,
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary.json": 947,
	"./components/UserMainSettings/UserPersonalData/index": 914,
	"./components/UserMainSettings/UserPersonalData/index.tsx": 914,
	"./components/UserMainSettings/index": 994,
	"./components/UserMainSettings/index.tsx": 994,
	"./components/UserMainSettings/tests/__snapshots__/user-personal-data.spec.jsx.snap": 1202,
	"./components/UserMainSettings/tests/get-component-by-datatest-util": 1117,
	"./components/UserMainSettings/tests/get-component-by-datatest-util.js": 1117,
	"./components/UserMainSettings/tests/user-personal-data.spec": 1163,
	"./components/UserMainSettings/tests/user-personal-data.spec.jsx": 1163,
	"./components/UserSecuritySettings": 1028,
	"./components/UserSecuritySettings/": 1028,
	"./components/UserSecuritySettings/ModalBody": 949,
	"./components/UserSecuritySettings/ModalBody/": 949,
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary": 999,
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary.json": 999,
	"./components/UserSecuritySettings/ModalBody/index": 949,
	"./components/UserSecuritySettings/ModalBody/index.tsx": 949,
	"./components/UserSecuritySettings/ModalFooter": 1058,
	"./components/UserSecuritySettings/ModalFooter.tsx": 1058,
	"./components/UserSecuritySettings/ModalResponseError": 915,
	"./components/UserSecuritySettings/ModalResponseError/": 915,
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary": 950,
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary.json": 950,
	"./components/UserSecuritySettings/ModalResponseError/index": 915,
	"./components/UserSecuritySettings/ModalResponseError/index.tsx": 915,
	"./components/UserSecuritySettings/PasswordModal": 1091,
	"./components/UserSecuritySettings/PasswordModal.tsx": 1091,
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary": 857,
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary.json": 857,
	"./components/UserSecuritySettings/UserSecuritySettings.module.scss": 858,
	"./components/UserSecuritySettings/changePassword": 948,
	"./components/UserSecuritySettings/changePassword.ts": 948,
	"./components/UserSecuritySettings/constants": 1057,
	"./components/UserSecuritySettings/constants.ts": 1057,
	"./components/UserSecuritySettings/index": 1028,
	"./components/UserSecuritySettings/index.tsx": 1028,
	"./components/UserSecuritySettings/password-form-validation": 1059,
	"./components/UserSecuritySettings/password-form-validation.ts": 1059,
	"./components/UserStakeSettings": 1000,
	"./components/UserStakeSettings/": 1000,
	"./components/UserStakeSettings/UserStakeSettings.dictionary": 1060,
	"./components/UserStakeSettings/UserStakeSettings.dictionary.json": 1060,
	"./components/UserStakeSettings/index": 1000,
	"./components/UserStakeSettings/index.tsx": 1000,
	"./components/constants": 886,
	"./components/constants.ts": 886,
	"./components/types": 1061,
	"./components/types/": 1061,
	"./components/types/index": 1061,
	"./components/types/index.ts": 1061,
	"./components/types/userEmail": 1164,
	"./components/types/userEmail.ts": 1164,
	"./components/types/userPhone": 1165,
	"./components/types/userPhone.ts": 1165,
	"./components/utils/error-alert-utils": 376,
	"./components/utils/error-alert-utils.ts": 376,
	"./components/utils/hide-symbols-utils": 1090,
	"./components/utils/hide-symbols-utils.ts": 1090,
	"./index": 310,
	"./index.tsx": 310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1281;
module.exports = webpackContext;